import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaUser,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaArrowRight,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { GiFairyWings } from "react-icons/gi";
import "./AdminSignIn.css";

export default function AdminSignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const API_BASE_URL =
        process.env.REACT_APP_API_BASE_URL || "https://localhost:5000";
      const res = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      let data = null;

      try {
        data = await res.json();
      } catch (e) {
        console.log("Invalid JSON response");
      }
      if (res.ok && data && data.success) {
        sessionStorage.setItem("adminToken", data.token);
        sessionStorage.setItem("adminRefreshToken", data.refreshToken);
        navigate("/admin/add-slider");
      } else if (data && data.message) {
        setError(data.message);
      } else {
        setError("Incorrect email or password");
      }
    } catch (err) {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Helmet>
            <title>Sign In | Rajput Shiksha Kosh</title>
    
            <meta
              name="description"
              content="Sign in to your Rajput Shiksha Kosh account to view and manage your dashboard."
            />
          </Helmet>
    <div className="admin-signin-wrapper">
      <div className="admin-signin-card">
        {/* --- Header & Divider --- */}
        <div className="admin-signin-header">
          <h2 className="admin-signin-title">ADMIN LOGIN</h2>
          <div className="admin-signin-divider">
            <span className="admin-signin-line"></span>
            <GiFairyWings className="admin-signin-icon-wings" />
            <span className="admin-signin-line"></span>
          </div>
          <p className="admin-signin-subtitle">
            Welcome back! Please sign in to your dashboard.
          </p>
        </div>

        {/* --- FORM --- */}
        <form onSubmit={submit} autoComplete="on">
          {/* Email Input */}
          <div className="admin-signin-input-wrapper">
            <FaUser className="admin-signin-icon" />
            <input
              id="admin-email"
              name="email"
              className="admin-signin-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
              autoComplete="email"
              required
            />
          </div>

          {/* Password Input */}
          <div className="admin-signin-input-wrapper">
            <FaLock className="admin-signin-icon" />
            <input
              id="admin-password"
              name="password"
              className="admin-signin-input"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="admin-signin-eye-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {/* Error Message */}
          {error && <div className="admin-signin-error">{error}</div>}

          {/* Submit Button (Donate Now Style) */}
          <button
            className="admin-signin-submit-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              "Authenticating..."
            ) : (
              <>
                <span className="admin-signin-btn-text">Sign In securely</span>{" "}
                <FaArrowRight />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
    </>
  );
}
